import { Box, Button, CircularProgress, Stack, Typography } from '@mui/material';

export default function KnowledgeAnalysisState({
    pending,
    error,
    onRetry,
}: {
    pending: boolean;
    error: string;
    onRetry: () => void;
}) {
    if (pending)
        return (
            <Stack
                role="status"
                direction="row"
                spacing={1.5}
                alignItems="center"
                sx={{ py: 1 }}
            >
                <CircularProgress
                    size={20}
                    aria-hidden="true"
                />
                <Box>
                    <Typography sx={{ fontSize: 14, fontWeight: 600 }}>Анализируем сайт</Typography>
                    <Typography sx={{ fontSize: 13, color: 'var(--lm-muted)' }}>
                        После анализа проверьте факты перед сохранением.
                    </Typography>
                </Box>
            </Stack>
        );
    if (!error) return null;
    return (
        <Stack
            role="alert"
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
            alignItems={{ xs: 'stretch', sm: 'center' }}
            sx={{
                p: 1.5,
                borderRadius: 2,
                bgcolor: 'var(--lm-danger-bg)',
                border: '1px solid var(--lm-danger-border)',
            }}
        >
            <Typography sx={{ flex: 1, fontSize: 14, color: 'var(--lm-danger-ink)', overflowWrap: 'anywhere' }}>
                {error}
            </Typography>
            <Button
                onClick={onRetry}
                sx={{ flexShrink: 0, minHeight: 44, color: 'var(--lm-danger-ink)', fontFamily: 'inherit' }}
            >
                Повторить анализ
            </Button>
        </Stack>
    );
}
